/*
 * @Author: Vanny
 * @Date: 2019-12-12 17:36:45
 * @LastEditors: Vanny
 * @LastEditTime: 2019-12-13 15:36:12
 * @Description: Loading
 */
import Vue from "vue"
import Loading from "./Loading"

const Indicator = Vue.extend(Loading)

let instance

export default {
  open(options = {}) {
    if (!instance) {
      instance = new Indicator({
        el: document.createElement("div")
      })
    }
    if (instance.visible) return
    instance.text = typeof options === "string" ? options : options.text || ""
    instance.spinnerType = options.spinnerType || "snake"
    document.body.appendChild(instance.$el)
    Vue.nextTick(() => {
      instance.visible = true
    })
  },

  close() {
    if (instance) {
      instance.visible = false
    }
  }
}
